import React, {useState} from 'react'
import { DataGrid } from '@mui/x-data-grid';
import Situation from './Situation';

export const SituationList = (props) => {
  const [rows, setRows] = useState(props.rows);

  const model = {
    columns: [
      {
        field: "Situation_Heading",
        headerName: "Situation",
        flex: 1,
        renderCell: (params) => {
          return (
            <Situation {...params.row} behaviors={props.behaviors} />
          );
        },
      }
    ],
    modulename: "Behaviors"
  };

  return (
    <div className="data-container">
        <DataGrid
            autoHeight={true}
            getRowId={(row) => row.Id}
            rows={rows}
            getRowHeight={() => 'auto'}
            columns={model.columns}
            pageSize={100}
            headerHeight={0}
            rowsPerPageOptions={[100]}
            disableColumnFilter
            disableColumnMenu 
            disableSelectionOnClick ={true}
            sx={{
              '.MuiDataGrid-columnSeparator': {
                display: 'none',
              },
            }}
            />
    </div>
  )
}
